<template>
<!-- 海报首页 -->
  <div class="school-card">
      <div @click="$router.push('/report_card_form')" class="btn">
        <img class="btn" src="@a/other/report_card_poster/begin-btn.png" alt="">
      </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{

        }
    },
    methods:{
        pullData(){
            document.title = '新精英“ 老学员成绩单 ”';
            shareCon("index", this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style  lang="scss" scoped>
.school-card{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../../../assets/other/report_card_poster/idx-bg.png') center no-repeat;
    background-size: cover;
    .btn{
        width: 360px;
        height: 66px;
        box-shadow: 0px 0px 13px 8px rgba( #FEF280, 0.35);
        background-color: #FEF280;
        text-align: center;
        border: none;
        border-radius: 33px;
        position: absolute;
        bottom: 245px;
        left: 50%;
        transform: translateX(-50%);
        img{
            width: 152px;
            height: 34px;
            position: absolute;
            bottom: 15px;
        }
    }
}


</style>